/**
 * Anel de saude do cliente (engajamento) — usa as classes canonicas
 * `.health-ring` (+ tone good/warn/bad) de styles/canonical/comercial.css.
 *
 * Fiel ao mockup fase-3 (Lista Clientes): SVG viewBox 0 0 48 48, r=20,
 * stroke-dasharray = score% de ~126 (circunferencia). Score null = "—"
 * (cliente sem historico), sem arco preenchido.
 */
import React from "react";

const CIRCUNFERENCIA = 126; // ~ 2*PI*20 (raio do circulo no viewBox 48)

const TONE_POR_TIER = {
  saudavel: "good",
  atencao: "warn",
  em_risco: "bad",
};

export default function HealthRing({ score = null, tier = null, size = 44 }) {
  const temScore = typeof score === "number" && Number.isFinite(score);
  const toneClass = TONE_POR_TIER[tier] || "";
  const preenchido = temScore
    ? `${(Math.max(0, Math.min(100, score)) / 100) * CIRCUNFERENCIA} ${CIRCUNFERENCIA}`
    : null;
  // Escala o numero com o tamanho: lista (32/48) fica em 10/12; cockpit (120)
  // usa ~28 como no mockup. Acima de 90px o numero acompanha o anel grande.
  const fontSize = size <= 34 ? 10 : size >= 90 ? 28 : 12;

  return (
    <div
      className={`health-ring${toneClass ? ` ${toneClass}` : ""}`}
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      <svg width={size} height={size} viewBox="0 0 48 48">
        <circle className="health-ring__bg" cx="24" cy="24" r="20" />
        {temScore && (
          <circle
            className="health-ring__fg"
            cx="24"
            cy="24"
            r="20"
            strokeDasharray={preenchido}
          />
        )}
      </svg>
      <span
        className="health-ring__num"
        style={fontSize === 12 ? undefined : { fontSize }}
      >
        {temScore ? score : "—"}
      </span>
    </div>
  );
}
